export default __webpack_public_path__ + "static/pultrudedfrp5-9f625cf10a1c823204b1813e23043350.jpg";